import * as React from 'react';
import translate from '../../../../locale/translate';

import { renderEmpty } from '../../common/Render';
import SimplePieChart from '../../common/Chart/SimplePieChart';
import { getDisplayValue, formatDate } from '../../util/StringUtil';

import { IReportSettings, PM } from '../../../../interfaces';

import ISettings from './ISettings';
import IWidgetProps from './IWidgetProps';


interface IProps extends IWidgetProps {
    settings: ISettings;
}

const AVAILABLE_COLS = [
    'name',
    'ScanState',
    'InstallState',
    'LastScanTime',
];

const COL_TITLES = {
    name: translate.gettext("Name"),
    ScanState: translate.gettext("Last scan state"),
    InstallState: translate.gettext("Last install state"),
    LastScanTime: translate.gettext("Last scan date"),
};

const HEADER_CLASSES = {
    name: '',
    ScanState: 'col-xs-2',
    InstallState: 'col-xs-2',
    LastScanTime: 'col-xs-2',
};

const COL_CLASSES = {
    name: '',
    ScanState: '',
    InstallState: '',
    LastScanTime: '',
};

export default class Widget extends React.Component<IProps, {}> {
    static propTypes = {
        systems: React.PropTypes.array.isRequired,
        settings: React.PropTypes.object.isRequired,
        reportSettings: React.PropTypes.object.isRequired,
    };

    getRowCls(system: PM.ISystem) {
        if (!system.pmInformation) {
            return 'warning';
        }

        return '';
    }

    renderColumnHead(name: string, settings: ISettings) {
        if (getDisplayValue(name, settings)) {
            return (
                <th key={name} className={HEADER_CLASSES[name]}>{COL_TITLES[name]}</th>
            );
        }

        return;
    }

    renderColumn(name: string, system: PM.ISystem, settings: ISettings) {
        if (getDisplayValue(name, settings)) {
            let value = system[name];

            if (!value && system.pmInformation) {
                value = system.pmInformation[name];
            } else if (!value && !system.pmInformation) {
                value = translate.gettext('No PM installed');
            }

            if (name === 'LastScanTime' && system.pmInformation) {
                value = formatDate(value, 'L LT');
            }

            return (
                <td key={name} className={COL_CLASSES[name]}>{value}</td>
            );
        }

        return;
    }

    renderSystem(system: PM.ISystem, settings: ISettings) {
        return (
            <tr key={system.id} className={this.getRowCls(system)}>
                {AVAILABLE_COLS.map(name => {
                    return this.renderColumn(name, system, settings);
                })}
            </tr>
        );
    }

    getChartData(systems: PM.ISystem[]) {
        return systems.reduce((systemCount, system: PM.ISystem) => {
            if (system.pmInformation) {
                systemCount.has++;
            } else {
                systemCount.hasNo++;
            }

            return systemCount;
        }, {
            has: 0,
            hasNo: 0,
        });
    }

    renderChart({ has, hasNo }) {
        const data = [
            { x: translate.gettext('Without PM'), y: hasNo },
            { x: translate.gettext('With PM'), y: has },
        ];

        return (
            <div key="chart" className="text-center">
                <SimplePieChart data={data} />
            </div>
        );
    }

    renderData(systems: PM.ISystem[], settings: ISettings, reportSettings: IReportSettings) {
        const headers = AVAILABLE_COLS.map(name => {
            return this.renderColumnHead(name, settings);
        }).filter(header => !!header);

        const rows = systems.map((system, idx) => {
            return this.renderSystem(system, settings);
        });

        const children = [];

        if (settings.displayChart) {
            children.push(this.renderChart(this.getChartData(this.props.systems)));
        }

        if (settings.displayTable) {
            children.push(
                <table className="table" key="table">
                    <thead>
                        <tr>
                            {headers}
                        </tr>
                    </thead>
                    <tbody>
                        {rows}
                    </tbody>
                </table>
            );
        }

        return (
            <div>
                {children}
            </div>
        );
    }

    render() {
        let { systems } = this.props;
        const { settings, reportSettings } = this.props;

        systems = systems.filter(system => {
            if (!system.pmInformation && !settings.displaySystemsWithoutPm) {
                return false;
            }

            return true;
        });

        let renderedData;
        if (systems && systems.length) {
            renderedData = this.renderData(systems, settings, reportSettings);
        } else {
            renderedData = renderEmpty();
        }

        return (
            <div>
                {renderedData}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/pm/listSystems/Widget.tsx